import lodashCloneDeep from "lodash/cloneDeep";

import { httpGet } from "@/services/api.service";
import { ENDPOINT_TAGS_CONFIG } from "@/common/constants/api";
import { hasPlusCyberAccess } from "@/services/user/user.service";

export { _getTagsConfig as getTagsConfig };
export { _getTagsLabelsByCodes as getTagsLabelsByCodes };

let tagsConfig = null;

const _getTagsConfig = async () => {
  if (!tagsConfig) {
    try {
      const url = ENDPOINT_TAGS_CONFIG;
      const result = await httpGet({ url });
      const { data } = JSON.parse(result);
      let tagList = data.tags;
      const tagsAvailable = hasPlusCyberAccess()
        ? tagList
        : tagList.filter((tag) => !tag.isCyber);

      tagsConfig = tagsAvailable;
      return tagsAvailable;
    } catch (error) {
      console.error(
        "Issue getting risk rating categories in risks.service.js: ",
        error
      );
      return null;
    }
  }
  return lodashCloneDeep(tagsConfig);
};

const _getTagsLabelsByCodes = (tagIds, tagsList) => {
  return tagsList
    .filter((tag) => tagIds.includes(tag.id))
    .map((tag) => tag.label);
};
